import { v7 as uuidv7 } from "uuid";

/** The sole minting boundary for persistence-independent entity identities. */
export function mintEntityId(): string {
  return uuidv7();
}
